import { useState, useContext, useCallback } from "react";
import BorseContext from "../../context/borse";
import dayjs from "dayjs";
import localeData from "dayjs/plugin/localeData";
import "dayjs/locale/it";
import "dayjs/locale/fr";
import "dayjs/locale/es";
import "dayjs/locale/pt";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import Title from "../title";
import BorseSurvey from "./borse-survey";
import AppError from "../app-error";
import BorseContent from "./borse-content";
dayjs.extend(LocalizedFormat);
dayjs.extend(localeData);

const BorseBody = () => {
  const {
    labels,
    status,
    campaign,
    path,
    error,
    appLang,
    currentRequest,
    requests,
    setCurrentRequest,
    setPath,
    setCurrentSectionIndex,
    isFetching,
  } = useContext(BorseContext);

  const [discardModal, setDiscardModal] = useState(false);

  const handleClick = useCallback(
    (index) => {
      setPath((current) => current.slice(0, index + 1));
      setCurrentSectionIndex(index);
    },
    [setPath, setCurrentSectionIndex]
  );

  return error ? (
    <AppError labels={labels} />
  ) : isFetching ? (
    <div className="loading-spinner mt" />
  ) : (
    <>
      <Title
        description={
          currentRequest
            ? null
            : {
                closed:
                  labels?.WELFARE_BORSE_CLOSED_DESCRIPTION_BANNER ||
                  "The initiative is currently closed. You will receive an email when you can apply for scholarships",
                "invalid-campaign":
                  labels?.WELFARE_BORSE_CLOSED_DESCRIPTION_BANNER ||
                  "The initiative is currently closed. You will receive an email when you can apply for scholarships",
                "request-phase": (
                  labels?.WELFARE_BORSE_OPEN_DESCRIPTION_BANNER ||
                  "<p><strong>You have until [DATE]</strong> to apply for a scholarship for yourself or your children</p>"
                )?.replace(
                  "[DATE]",
                  dayjs(Number(campaign?.applicationEndDate)).locale(appLang?.value).format("LL")
                ),
                "request-closed-phase":
                  requests?.length > 0 && labels?.WELFARE_BORSE_REQUEST_CLOSED_DESCRIPTION_BANNER,
                "evaluation-phase":
                  requests?.length > 0 && labels?.WELFARE_BORSE_EVALUATION_DESCRIPTION_BANNER,
              }[status]
        }
        showStepper={
          currentRequest && (currentRequest?.status === "DRAFT" || currentRequest === "new")
        }
        stepper={{
          sections: {
            "request-phase": currentRequest ? [0, 1, 2, 3] : null,
          }[status],
          currentSectionIndex: path?.length - 1,
          onClick: (index) => handleClick(index),
        }}
        button={
          status === "request-phase" && !currentRequest
            ? [
                {
                  action: () => setCurrentRequest("new"),
                  style: "primary",
                  label: labels?.WELFARE_BORSE_NEW_REQUEST || "New request",
                  className: "button app__title-button",
                },
              ]
            : []
        }
        handleNavigation={
          currentRequest
            ? currentRequest === "new" || currentRequest?.status === "DRAFT"
              ? () => setDiscardModal(true)
              : () => setCurrentRequest()
            : null
        }
        handleSticky={true}
      >
        {currentRequest
          ? currentRequest?.status === "DRAFT" || currentRequest === "new"
            ? labels?.WELFARE_BORSE_NEW_REQUEST_TITLE_BANNER || "New scholarship request"
            : currentRequest?.status === "EXPIRED_DRAFT"
            ? (
                labels?.WELFARE_BORSE_EXPIRED_DRAFT_TITLE_BANNER || "Expired draft request[SCHOOL]"
              ).replace("[SCHOOL]", currentRequest?.school ? ` - ${currentRequest?.school}` : "")
            : currentRequest?.status === "ASSIGNED"
            ? labels?.WELFARE_BORSE_WON_REQUEST_TITLE_BANNER
            : currentRequest?.status === "NOT_ASSIGNED"
            ? labels?.WELFARE_BORSE_REJECTED_REQUEST_TITLE_BANNER
            : currentRequest?.school
          : {
              closed: labels?.WELFARE_BORSE_CLOSED_TITLE_BANNER || "Closed initiative",
              "invalid-campaign": labels?.WELFARE_BORSE_CLOSED_TITLE_BANNER || "Closed initiative",
              "request-phase": labels?.WELFARE_BORSE_OPEN_TITLE_BANNER || "Open initiative",
              "request-closed-phase":
                requests?.length > 0
                  ? labels?.WELFARE_BORSE_REQUEST_CLOSED_TITLE_BANNER || "Request phase closed"
                  : labels?.WELFARE_BORSE_CLOSED_TITLE_BANNER || "Closed initiative",
              "evaluation-phase":
                requests?.length > 0
                  ? labels?.WELFARE_BORSE_EVALUATION_TITLE_BANNER || "Evaluation phase"
                  : labels?.WELFARE_BORSE_CLOSED_TITLE_BANNER || "Closed initiative",
              "evaluation-ended": labels?.WELFARE_BORSE_CLOSED_TITLE_BANNER || "Closed initiative",
            }[status]}
      </Title>
      {currentRequest ? (
        <BorseSurvey discardModal={discardModal} setDiscardModal={setDiscardModal} />
      ) : (
        <BorseContent />
      )}
    </>
  );
};

export default BorseBody;
